
      import { terminalAPI } from './demo/terminal-api.js';

      // eslint-disable-next-line no-undef
      athenaPec.terminalapi = terminalAPI;
    